exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._4AFh0-zjNlSw8sJtRZUJJ{height:16px;position:relative}._4AFh0-zjNlSw8sJtRZUJJ div{display:inline-block}._1KkVRtuZteI_qu72FIaDU5>div{height:24px;width:24px}._1_ji1pvC-Te0iPSUk1LlDh{font-size:10px;color:\"[theme:neutralSecondaryAlt, default:#767676]\";position:absolute;top:0}html[dir=ltr] ._1_ji1pvC-Te0iPSUk1LlDh{padding-left:4px}html[dir=rtl] ._1_ji1pvC-Te0iPSUk1LlDh{padding-right:4px}", ""]);
// Exports
exports.locals = {
	"indicatorContainer": "_4AFh0-zjNlSw8sJtRZUJJ",
	"personaCoinFix": "_1KkVRtuZteI_qu72FIaDU5",
	"isTypingText": "_1_ji1pvC-Te0iPSUk1LlDh"
};